module.exports = __webpack_public_path__ + "static/media/ChangEFactoryINTA0003_design_clean_v003.0d2f6717.webp";